import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function canAccessThematicPrograms(user) {
  if (!user) return false;
  return Boolean(
    user.is_student || user.is_teacher || user.is_staff || user.is_admin
  );
}

/** Страницы тематических программ (ЕГЭ и т.д.): ученик, преподаватель, staff/admin. */
export default function ThemesRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessThematicPrograms(user)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
